export const stripHtml = (value?: string | null): string => {
  if (!value) return ''
  if (!/[<&]/.test(value)) return value

  const withoutTags = value.replace(/<[^>]*>/g, ' ')
  const textarea = document.createElement('textarea')
  textarea.innerHTML = withoutTags

  return textarea.value.replace(/\s+/g, ' ').trim()
}
